module.exports = __webpack_public_path__ + "static/media/test21_4.ac6b8efa.png";